import { Link } from 'react-router-dom';

interface HeaderLogoProps {
  logoUrl?: string;
}

export function HeaderLogo({ logoUrl }: HeaderLogoProps) {
  return (
    <div className="flex-shrink-0">
      <Link to="/" aria-label="Go to home page" className="outline-none block">
        <img
          src={logoUrl}
          alt="Company Logo"
          className="h-10 w-auto"
        />
      </Link>
    </div>
  );
}
